import { gql } from 'apollo-angular';

export const TOKEN_VERIFY = gql`
  query TokenVerify {
    me {
      id
      firstName
      lastName
      isStaff
      isActive
      isConfirmed
      email
    }
  }
`;

export const TOKEN_REFRESH = gql`
  mutation TokenRefresh($refreshToken: String!) {
    tokenRefresh(refreshToken: $refreshToken) {
      token
      errors {
        field
        message
      }
    }
  }
`;
